import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CreateEventInput, CreateEventSessionFacilitatorInput, CreateEventSessionInput, CreateEventSessionTimeInput } from '../../../API';
import { eventSessionTimes, groupEvents, groupEventSessionFacilitators, groupEventSessions } from '../../../data/events-setup4';
import { saveEvent, saveEventSession, saveEventSessionFacilitator, saveEventSessionTimes } from '../../../services/events';
const SetupGroups = () => {
  const processed = useRef(false);
  const [searchParams] = useSearchParams();
  const [force, setForce] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (!searchParams.get('force')) {
      setForce(true);
      return;
    }
    setForce(searchParams.get('force') === '1' ? true : false);
  }, [searchParams]);

  useEffect(() => {
    if (!processed.current && force !== undefined) {
      processed.current = true;
      //setup upcoming group event
      (async () => {
        groupEvents.forEach(async (item) => await saveEvent(item as CreateEventInput, { forceCreate: force }));
        groupEventSessions.forEach(async (item) => await saveEventSession(item as CreateEventSessionInput, { forceCreate: force }));
        eventSessionTimes.forEach(async (item) => await saveEventSessionTimes(item as CreateEventSessionTimeInput, { forceCreate: force }));
        groupEventSessionFacilitators.forEach(
          async (item) => await saveEventSessionFacilitator(item as CreateEventSessionFacilitatorInput, { forceCreate: force })
        );
      })();
    } else {
      console.log('Already proccessed');
    }
  }, [force]);
};
export default SetupGroups;
